import type { GiftPassListRow } from '../../api/gift-passes';

import { GIFT_PASS_SOURCE_LABEL, originDetail } from './gift-passes-model';

const DETAIL = {
  fontSize: 11.5,
  color: 'var(--nb-subtle)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: 220,
} as const;

export function GiftPassOriginCell({ row }: { row: GiftPassListRow }) {
  const detail = originDetail(row);
  return (
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: 13, fontWeight: 600 }}>{GIFT_PASS_SOURCE_LABEL[row.source]}</div>
      {detail && (
        <div className={row.source === 'REFUND' ? 'nb-mono' : undefined} style={DETAIL}>
          {detail}
        </div>
      )}
    </div>
  );
}
